import Swiper from 'swiper';
import SwiperCore, { Autoplay, EffectFade } from 'swiper/core';

export default () => {
    const sliderContainer = document.querySelector('.headerSlider');
    if (sliderContainer) {
        SwiperCore.use([EffectFade, Autoplay]);
        new Swiper(sliderContainer, {
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            loop: false,
            effect: 'fade',
            allowTouchMove: true,
            speed: 1800,
            threshold: 3,
            modules: [EffectFade, Autoplay],
        });
    }
};
